window.addEventListener('DOMContentLoaded', function() {
    console.log('page - custom js is running');

    let featuredProjectsSlider = this.document.querySelector('.featured-projects-slides');

    if(featuredProjectsSlider) {

        let sliderSettings = {
            arrows: true,
            dots: false,
            infinite: false,
            speed: 400,
            slidesToShow: 4,
            slidesToScroll: 4,
            nextArrow: '#arrow-next',
            prevArrow: '#arrow-prev',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        $(featuredProjectsSlider).slick(sliderSettings);
    }

    // Gallery Blends Slider
    let blendsSlider = this.document.querySelector('.page-color-palette-2-gallery .blends-slider');
    if(blendsSlider) {
        $('.page-color-palette-2-gallery .blends-slider').slick({
            slidesToShow: 1,
            arrows: false,
            dots: true,
            infinite: true,
        });

        $('.page-color-palette-2-gallery .blends-slider').on('afterChange', function(){
            var $active = $('.page-color-palette-2-gallery .blends-slider .slick-current').attr('data-slick-index');
            $('.page-color-palette-2-gallery .bg-img .bg').removeClass('show');
            $('.page-color-palette-2-gallery .bg-img .bg[data-id="' + $active + '"]').addClass('show');
        });

        $('.page-color-palette-2-gallery .arrow-left').click(function () {
            $('.page-color-palette-2-gallery .blends-slider').slick('slickPrev');
        });

        $('.page-color-palette-2-gallery .arrow-right').click(function () {
            $('.page-color-palette-2-gallery .blends-slider').slick('slickNext');
        });
    }
});